module.exports = __webpack_public_path__ + "img/yellow-check.930fb4f3.svg";